export const hubNames = {
	ALERTS: 'alertsHub',
};
